export default __webpack_public_path__ + "static/media/ASIA.6cc06b1c.svg";